// extracted by mini-css-extract-plugin
export default {"label":"x9YqHxPi5dGl_ZxEav0k","content":"Va7canbmz_v4OpHYToRq"};